import unescapedText from 'I18n/utils/unescapedText';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { Paths } from '../../constants/paths';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { CollectionSection } from './CollectionSection';
import { jsx as _jsx } from "react/jsx-runtime";
export function BreezeAgentsCollectionSection({
  sectionIndex
}) {
  const {
    data,
    error
  } = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      variables: {
        queryType: 'ELASTIC_SEARCH',
        length: 6,
        // Fetch 6 agents as requested
        offset: 0,
        filter: {
          filterGroups: [{
            filtersByField: {
              PRODUCT_TYPE: [{
                values: ['AGENT'],
                clause: 'OR',
                negation: false,
                __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery'
              }]
            },
            clause: 'AND',
            negation: false
          }],
          clause: 'AND',
          negation: false
        }
      }
    }
  });

  // Don't render if there's an error or no data
  if (error || !(data !== null && data !== void 0 && data.result.cards.length)) return null;

  // Convert empty string iconUrl to undefined
  const cardsWithCleanedIcons = data.result.cards.map(card => Object.assign({}, card, {
    iconUrl: card.iconUrl === '' ? undefined : card.iconUrl
  }));
  return /*#__PURE__*/_jsx(CollectionSection, {
    buttonText: unescapedText('marketplaceStorefront.breezeAgentsCollectionSection.buttonText'),
    cards: cardsWithCleanedIcons,
    collectionId: "BREEZE_AGENTS",
    collectionSlug: "breeze-agents" // Not used since we provide custom href
    ,
    description: unescapedText('marketplaceStorefront.breezeAgentsCollectionSection.description'),
    href: Paths.AGENTS,
    productType: "AGENT",
    sectionIndex: sectionIndex,
    title: unescapedText('marketplaceStorefront.breezeAgentsCollectionSection.title')
  });
}